import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { LandingPage } from './pages/LandingPage';
import { BookingPage } from './pages/BookingPage';
import { ImpressumPage } from './pages/ImpressumPage';
import { DatenschutzPage } from './pages/DatenschutzPage';
import { ImprintPage } from './pages/ImprintPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
export function App() {
  return <HelmetProvider data-id="element-0">
      <Router data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<LandingPage data-id="element-4" />} data-id="element-3" />
          <Route path="/Kostenloses-Strategiegespraech" element={<BookingPage data-id="element-6" />} data-id="element-5" />
          <Route path="/impressum" element={<ImpressumPage data-id="element-8" />} data-id="element-7" />
          <Route path="/datenschutz" element={<DatenschutzPage data-id="element-10" />} data-id="element-9" />
          <Route path="/en/imprint" element={<ImprintPage data-id="element-12" />} data-id="element-11" />
          <Route path="/en/privacy-policy" element={<PrivacyPolicyPage data-id="element-14" />} data-id="element-13" />
        </Routes>
      </Router>
    </HelmetProvider>;
}